__turbopack_context__.v({
  "posts-hero": "PostsHero-module-scss-module__vQ-ALG__posts-hero",
  "posts-title": "PostsHero-module-scss-module__vQ-ALG__posts-title",
});
